import axios from '../axios'

// 名簿（teacher=担当生徒 / admin=全生徒）
const getStudentsApi = async () => {
  return await axios.get('api/lms/students')
}

export default getStudentsApi
